module.exports = __webpack_public_path__ + "static/9-projects-transforming-the-campus-3541af823ce8020ec73fd783fac4e191.jpg";